class API {
    static ws = null;
    static token = null;
    static isAuthorized = true;
    static passwordCache = {
        password: null,
        valid: false
    };
    static nickname = null;

    static reconnect (onError, onThinking, onResponding, onSuccess, onAuthUpdate, language, onNicknameRequest) {
        if (this.ws) {
            this.disconnect();
        }
        this.token = null;

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('lang', language);
        const url = `${window.location.toString().replace('http', 'ws')
            .split('?')[0]}?${urlParams.toString()}`;

        this.ws = new WebSocket(url);
        this.ws.onerror = onError;
        this.ws.onmessage = msg => {
            const data = JSON.parse(msg.data);

            if (data.token) {
                this.token = data.token;
            }

            if (data.status === 'success') {
                if (data.thoughts) console.info(data.thoughts); // debug printing
                onSuccess(data.response);
            } else if (data.status === 'error') {
                onError(data);
                this.disconnect();
            } else if (data.status === 'in progress') {
                if (data.thinking) onThinking(data.thinking);
                if (data.responding) onResponding(data.responding);
            } else if (data.status === 'auth_required') {
                // try cached password (maybe just reconnecting)
                if (this.passwordCache.valid) {
                    this.authorize(this.passwordCache.password);
                    this.passwordCache.valid = false; // invalidate after use
                }

                this.isAuthorized = false;
                onAuthUpdate({isAuthorized: this.isAuthorized});
            } else if (data.status === 'auth_ok') {
                this.isAuthorized = true;
                onAuthUpdate({isAuthorized: this.isAuthorized});
                this.passwordCache.valid = true; // re-validate if correct
            } else if (data.status === 'nickname_requested') {
                if (this.nickname) {
                    this.announceNickname();
                } else {
                    onNicknameRequest();
                }
            }
        };
    }

    static disconnect () {
        if (this.ws) {
            this.ws.close();
        }
    }

    static authorize (password) {
        if (!this.ws) throw Error('WebSocket is not connected.');
        if (this.ws.readyState !== WebSocket.OPEN) {
            throw Error(`WebSocket is not ready, state was: ${this.ws.readyState}`);
        }
        this.passwordCache.password = password;
        this.passwordCache.valid = false; // avoid resending twice
        this.ws.send(JSON.stringify({
            password
        }));
    }

    static announceNickname () {
        if (!this.nickname) {
            return;
        }
        if (!this.ws) throw Error('WebSocket is not connected.');
        if (this.ws.readyState !== WebSocket.OPEN) {
            throw Error(`WebSocket is not ready, state was: ${this.ws.readyState}`);
        }
        this.ws.send(JSON.stringify({
            nickname: this.nickname,
            token: this.token
        }));
    }
    static sendNickname (nickname) {
        this.nickname = nickname;
        this.announceNickname();
    }

    static send (question, selectedSprite, project, screenshot) {
        if (!this.ws) throw Error('WebSocket is not connected.');
        if (this.ws.readyState !== WebSocket.OPEN) {
            throw Error(`WebSocket is not ready, state was: ${this.ws.readyState}`);
        }
        this.ws.send(JSON.stringify({
            question,
            selectedSprite,
            project,
            screenshot,
            token: this.token
        }));
    }
}

export default API;
